import { LANGUAGE } from '../constants';
import { Language } from '../types/common';
import type { OptionsType } from '../types/options';

/**
 * 商社コードから商社名を返す。該当する商社が見つからなかったら商社コードをそのまま帰す。
 * @param steelCategoryCode [string]
 * @param steelCategories [OptionsType[]]
 * @param language? [Language]
 * @returns [string]
 */
const getSteelCategoryName = (steelCategoryCode: string, steelCategories: OptionsType[], language?: Language): string => {
  // 商社の検索
  const steelCategory: OptionsType | undefined = steelCategories?.find((category) => category.code === steelCategoryCode);
  const steelCategoryName: string = steelCategory
    ? language
      ? language === LANGUAGE.EN
        ? steelCategory.nameEnglish
          ? steelCategory.nameEnglish
          : steelCategory.nameJapanese
        : steelCategory.nameJapanese
      : steelCategory.nameJapanese
    : steelCategoryCode;
  return steelCategoryName;
};

export default getSteelCategoryName;
